import React, {
  createContext,
  useState,
  useContext,
  useEffect,
  useCallback,
} from "react";

// Create the context
export const FilterContext = createContext(null);

export const useArn = () => {
  const arnContext = useContext(FilterContext);

  if (!arnContext) {
    throw new Error("useArn must be used within a FilterProvider");
  }

  return arnContext;
};

// Provider component
export const FilterProvider = ({ children }) => {
  // const [arn, setArn] = useState(() => localStorage.getItem("arn") ?? "");
  const [arn, setArn] = useState(() => {
    return (
      localStorage.getItem("arn") ??
      localStorage.getItem("incoming_parArn") ??
      ""
    );
  });

  const [childArn, setChildArn] = useState(
    () => localStorage.getItem("childArn") ?? ""
  );
  const [isFilterReady, setIsFilterReady] = useState(true);
  const [superArn, setSuperArn] = useState(
    () => localStorage.getItem("superArn") ?? ""
  );
  const [chassisNumber, setchassisNumber] = useState("");
  const [isOpen, setIsOpen] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);

  const [isvOpen, setIsvOpen] = useState(false);
  const [pvinaccName, setPvinaccname] = useState(() => localStorage.getItem("accountName") ?? "")

  const [accountName, setAccountName] = useState(() => localStorage.getItem("accountName") ?? "");
  const [childCount, setChildCount] = useState(0);
  const [isGoldenArn, setIsGoldenArnD] = useState(false);
  const [submenuOpen, setSubmenuOpen] = useState(null);
  const [open, setOpen] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const [selectedSearchType, setSelectedSearchType] = useState("");
  const [clicked, setClicked] = useState(false);
  const [complaintButtonName, setComplaintButtonName] =
    useState("totalComplaints");
  const [isToggle, setIstoggle] = useState(false);
  const [l2, setL2] = useState(false);

  const [title, setIsTitle] = useState("Customer360");
  // Complaints
  const [complaintsFilterPayload, setComplaintsFilterPayload] = useState(null);
  const [complaintsPayload, setComplaintsPayload] = useState(null);
  // Spare sales Payload
  const [spareSalesPayload, setSpareSalesPayload] = useState(null);
  const [spareSalesFilterPayload, setSpareSalesFilterPayload] = useState(null);
  // Vehicle Payload
  const [vehiclePayload, setVehiclePayload] = useState(null);
  const [vehicleFilterPayload, setVehicleFilterPayload] = useState(null);
  const [selectedValue, setSelectedValue] = useState("");

  // JC payload
  const [jcDropDownPayload, setJcDropDownPayload] = useState(null);
  const [jcPayload, setJcPayload] = useState(null);

  const [selectedArn, setSelectedArn] = useState(null);
  const [childDatain, setChildDatain] = useState([]);
  const [childData, setChildData] = useState([]);
  const [selectedYear, setSelectedYear] = useState("2022-23"); // default year
  const [selectedYearcomp, setSelectedYearcomp] = useState("2022-23");
  const [pvinsprArn, setPvinsprArn] = useState(
    () => localStorage.getItem("superArn") ?? "");


  // landing page info cards

  const [datat, setDatat] = useState("");
  const [dealers, setDealers] = useState("")
  const [city, setCity] = useState("")
  const [citylist, setCitylist] = useState("")
  const [age, setAge] = useState("")
  const [dealerslist, setDealerslist] = useState(null)
  const [fleetid, setFleetid] = useState("")



  // FleetEdge payload
  const [fleetEdgeDropDownPayload, setFleetEdgeDropDownPayload] =
    useState(null);
  const [fleetedgePayload, setFleetEdgePayload] = useState(null);

  // Reffereal
  const [referralProspects, setReferralProspects] = useState("")
  // const [optyCount, setOptyCount] = useState(null)

  const handleClick = () => {
    setClicked((prev) => !prev);
  };


  useEffect(() => {
    const storedArn = localStorage.getItem("arn");
    const storedChildArn = localStorage.getItem("childArn");
    setArn(storedArn ?? "");
    setChildArn(storedChildArn ?? "");
    if (!isFilterReady) setIsFilterReady(true); // Avoid resetting
  }, []);

  useEffect(() => {
    if (arn) localStorage.setItem("arn", arn);
  }, [arn]);

  useEffect(() => {
    if (childArn) localStorage.setItem("childArn", childArn);
  }, [childArn]);

  useEffect(() => {
    if (superArn) {
      localStorage.setItem("superArn", superArn);
    }
  }, [superArn]);

  useEffect(() => {
    if (accountName) {
      localStorage.setItem("accountName", accountName)
    }
  }, [accountName])

  const contextValue = {
    superArn,
    setSuperArn,
    arn,
    setArn, pvinsprArn, setPvinsprArn,
    childArn,
    setChildArn,
    chassisNumber,
    setchassisNumber, datat, setDatat, citylist,
    setCitylist, age, setAge, dealerslist,
    setDealerslist,
    dealers, fleetid, selectedArn, setSelectedArn, childDatain, setChildDatain, childData, setChildData,
    setFleetid,
    setDealers,
    city,
    setCity,
    accountName,
    setAccountName,
    childCount,
    setChildCount,
    isGoldenArn,
    modalOpen, setModalOpen, selectedYear, setSelectedYear, selectedYearcomp, setSelectedYearcomp,
    open,
    setOpen,
    setIsGoldenArnD, selectedValue, setSelectedValue,
    setSubmenuOpen,
    submenuOpen,
    title,
    setIsTitle,
    isOpen,
    setIsOpen,
    isvOpen,
    setIsvOpen,
    complaintsFilterPayload,
    setComplaintsFilterPayload,
    spareSalesPayload, pvinaccName, setPvinaccname,
    setSpareSalesPayload,
    vehiclePayload,
    setVehiclePayload,
    complaintsPayload,
    setComplaintsPayload,
    jcDropDownPayload,
    setJcDropDownPayload,
    jcPayload,
    setJcPayload,
    vehicleFilterPayload,
    setVehicleFilterPayload,
    spareSalesFilterPayload,
    setSpareSalesFilterPayload,
    fleetEdgeDropDownPayload,
    setFleetEdgeDropDownPayload,
    fleetedgePayload,
    setFleetEdgePayload,
    isFilterReady,
    //////////////////////////
    searchData,
    setSearchData,
    clicked,
    handleClick,
    complaintButtonName,
    setComplaintButtonName,
    l2,
    setL2,
    isToggle,
    setIstoggle,
    selectedSearchType,
    setSelectedSearchType,
    // Refferal
    referralProspects,
    setReferralProspects,
    // optyCount, 
    // setOptyCount
  };

  // console.log("Open--", open, submenuOpen)
  return (
    <FilterContext.Provider value={contextValue}>
      {children}
    </FilterContext.Provider>
  );
};
// export default FilterProvider;
